<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>
<div class="container " style="margin-top:50px">

    <mat-tab-group>
        <mat-tab label="Shipping Address" style="font-size:20px">
                <div class="row" *ngIf="dataship && dataship.length > 0;">
                        <div class="col-12">
                                <button class="btn btn-secondary btn-block" end clear
                                (click)="goToAddress(1)">
                                    <mat-icon style="font-size: 18px;
                                    padding-bottom: 3px;
                                    margin-right: 5px;">add</mat-icon>Another Shipping Address</button>
                        </div>
                    </div>

                    <div class="row" *ngIf="dataship && dataship.length == 0;">
                            <div class="col-12">
                                    <button class="btn btn-secondary btn-block" end clear
                                    (click)="goToAddress(1)">
                                        <mat-icon style="font-size: 18px;
                                        padding-bottom: 3px;
                                        margin-right: 5px;">add</mat-icon>Add Shipping Address</button>
                            </div>
                        </div>


            <mat-radio-group name="ship" [(ngModel)]=" selectedShipaddid">
              <mat-card *ngFor="let data of dataship">
                  <div class = "row">
                      <div class = "col-4 col-center" style="margin-top:50px">
                          <mat-radio-button [checked]= "data.isdefault ==1" value = {{data.id}} (click)="changeradio(data.id)"></mat-radio-button>
                      </div>
                      <div class = "col-8" *ngIf="dataship && dataship.length>0">
                          <label>{{data.add_l1}} , {{data.add_l2}}</label>
                          <label>{{city}}</label>
                          <label>{{state}}</label>
                          <label>{{country}}</label>
                          <label> Pin: {{data.pin}}</label>
                          <label> Mobile: {{data.phone}}</label>
                    </div>
                      </div>
                      <div class="row">
                          <div class="col-4 text-center">
                                <label *ngIf="data.isdefault==1" style="font-family: open-sans;font-size: 18px; color: #cb983f" >** Set As Default</label>
                          </div>
                          <div class="col-8 text-center">
                              <div class="row">
                                  <div class="col">
                                        <button *ngIf="data.id == editflag" class="btn btn-secondary btn-block"
                                        (click)='editAddress(data.id,1)' full>edit</button>
                                  </div>
                                  <div class="col">
                                        <button  *ngIf="!(data.isdefault === 1)" class="btn btn-success3 btn-block"
                                        (click)="deleteShippingAddress(data.id)">
                                         Remove</button>
                                    </div>
                              </div>


                            </div>
                      </div>
              </mat-card>
              </mat-radio-group>
              <div class="row"  *ngIf="this.dataship && this.dataship.length>0 && adtitle === 'manageprofile'">
                    <div class="col">
                            <button class="btn btn-success btn-block" end clear style="margin-bottom: 1%"
                            (click)="onSetShippingAddress()">
                            Set As Shipping Address</button>
                    </div>
                </div>
                <div class="row"  *ngIf="this.dataship && this.dataship.length>0 && adtitle === 'checkout'">
                        <div class="col">
                                <button class="btn btn-success btn-block" end clear style="margin-bottom: 1%"
                                (click)="onSetShippingAddress()">
                                Deliver Here</button>
                        </div>
                    </div>
       </mat-tab>
        <mat-tab style="font-size:20px" label="Billing Address" >
        <mat-card *ngIf="billship && billship.length>0; else addbilladdress">
            <mat-card-content>
               <div class="row">
                   <div class= "col-6">
                    <label>
                            {{billship[0].add_l1}},{{billship[0].add_l2}}
                    </label>
                   </div>
                   <div class= "col-3">
                        <label>   City : {{city}}</label>
                             </div>
                <div class= "col-3">
                    <label> State : {{state}}</label>
                        </div>
                       </div>
                       <div class="row">
                            <div class= "col">
                             <label>
                                    Country : {{country}}
                             </label>
                            </div>
                            <div class= "col">
                                 <label>    Pin : {{billship[0].pin}}</label>
                                      </div>
                         <div class= "col">
                             <label>    Mobile : {{billship[0].phone}}</label>
                                 </div>
                                </div>
                            </mat-card-content>
                            <mat-card-actions>
                                <div class="row">
                                    <div class="col-4">
                                            <button class="btn btn-success3 btn-block" end clear style="margin-bottom: 1%"
                                            (click)=" editAddress(billship[0].id,2)">Edit</button>
                                    </div>
                                    <div class="col-8">
                                            <button class="btn btn-secondary btn-block" end clear style="margin-bottom: 1%"
                                            (click)=" setAsShipping()">Set As Shipping</button>
                                        </div>
                                </div>
                            </mat-card-actions>
                      </mat-card>
                    </mat-tab>
      </mat-tab-group>

</div>

<ng-template #addbilladdress >

  <button class="btn btn-secondary btn-block" end clear
  (click)="goToAddress(2)">
      <mat-icon style="font-size: 18px;
      padding-bottom: 3px;
      margin-right: 5px;">add</mat-icon>Add Billing Address</button>

        
              </ng-template>
